Object.assign(Q, {
  v19: {
    id:'v19', type:'single', phase:'Sport — herstel',
    text:'Hoe lang duurt jouw spierherstel gemiddeld na een zware training?',
    options:[
      {text:'24 uur of minder',value:'snel'},
      {text:'24–48 uur',value:'normaal',scores:{sport:1}},
      {text:'48–72 uur',value:'langzaam',scores:{sport:2}},
      {text:'Langer dan 72 uur of ik heb structurele klachten',value:'heel_langzaam',scores:{sport:3}}
    ]
  },
  v20: {
    id:'v20', type:'single', phase:'Sport — herstel',
    text:'Wat is voor jou op dit moment het grootste obstakel in je sportprestaties of herstel?',
    options:[
      {text:'Spierpijn die te lang aanhoudt',value:'spierpijn',scores:{sport:2,pijn:1}},
      {text:'Blessures of pijn',value:'blessure',scores:{pijn:2,sport:1}},
      {text:'Te weinig energie of motivatie',value:'energie',scores:{energie:2}},
      {text:'Te weinig spiermassa of kracht opbouwen',value:'opbouw',scores:{sport:1}},
      {text:'Slechte slaap na inspanning',value:'slaap',scores:{slaap:2}}
    ]
  },
  v21: {
    id:'v21', type:'single', phase:'Sport — herstel',
    text:'Gebruik je op dit moment iets voor herstel?',
    options:[
      {text:'Nee, niets speciaals',value:'nee'},
      {text:'Eiwitshake of creatine',value:'eiwit'},
      {text:'Supplementen (curcumine, omega-3, etc.)',value:'supplementen'},
      {text:'Koude therapie, sauna of massage',value:'therapie'},
      {text:'Meerdere van bovenstaande',value:'meerdere'}
    ]
  },
  v22: {
    id:'v22', type:'single', phase:'Metabolisme — verdieping',
    text:'Wat is voor jou de grootste uitdaging als het gaat om gewicht of stofwisseling?',
    options:[
      {text:'Ik val niet af ondanks dat ik het probeer',value:'geen_resultaat',scores:{afslanken:2}},
      {text:'Ik kom snel aan, ook als ik weinig eet',value:'aanmaken',scores:{afslanken:2}},
      {text:'Cravings en trek in suiker / zout',value:'cravings',scores:{afslanken:2}},
      {text:'Schommelende bloedsuiker (energy crashes)',value:'schommelen',scores:{afslanken:1,lever:1}}
    ]
  },
  v22b: {
    id:'v22b', type:'single', phase:'Metabolisme — verdieping',
    text:'Hoe zou je jouw eetpatroon omschrijven?',
    options:[
      {text:'Redelijk gezond en gevarieerd',value:'gezond'},
      {text:'Wisselend — soms goed, soms niet',value:'wisselend'},
      {text:'Veel bewerkt voedsel of snacks',value:'bewerkt',scores:{afslanken:1,lever:1}},
      {text:'Ik eet weinig maar kom toch aan',value:'weinig',scores:{afslanken:2}}
    ]
  },
  v22c: {
    id:'v22c', type:'single', phase:'Metabolisme — verdieping',
    text:'Sport of beweeg je regelmatig?',
    options:[
      {text:'Ja, meerdere keren per week',value:'ja_veel'},
      {text:'Soms — 1 à 2 keer per week',value:'soms'},
      {text:'Nauwelijks',value:'nauwelijks',scores:{afslanken:1}},
      {text:'Ik wil meer bewegen maar het lukt niet',value:'wil_meer',scores:{afslanken:1}}
    ]
  },
  v22d: {
    id:'v22d', type:'single', phase:'Metabolisme — verdieping',
    text:'Heb je vermoeden van een traag metabolisme of hormonale invloed?',
    options:[
      {text:'Ja, ik denk dat mijn stofwisseling traag is',value:'traag',scores:{afslanken:2}},
      {text:'Mogelijk — ik zie het in mijn familie',value:'mogelijk',scores:{afslanken:1}},
      {text:'Nee, ik denk dat het gedrag is',value:'gedrag'},
      {text:'Weet ik niet',value:'onbekend'}
    ]
  },
  v23: {
    id:'v23', type:'single', phase:'Huid & uiterlijk — verdieping',
    text:'Waarop wil je je focussen?',
    options:[
      {text:'Huid — gloed, textuur, veroudering',value:'huid',scores:{beauty:2}},
      {text:'Haar — dikte, uitval, kwaliteit',value:'haar',scores:{beauty:2}},
      {text:'Nagels — broos of langzame groei',value:'nagels',scores:{beauty:1}},
      {text:'Alles — een algemene verbetering',value:'alles',scores:{beauty:2}}
    ]
  },
  v23b: {
    id:'v23b', type:'single', phase:'Huid & uiterlijk — verdieping',
    text:'Heb je specifieke huidklachten?',
    options:[
      {text:'Droge of doffe huid',value:'droog',scores:{beauty:1}},
      {text:'Acne of onzuiverheden',value:'acne',scores:{beauty:2}},
      {text:'Eczeem, psoriasis of rosacea',value:'eczeem',scores:{beauty:2}},
      {text:'Rimpels of slap worden',value:'veroudering',scores:{beauty:2}},
      {text:'Geen specifieke klacht',value:'geen'}
    ]
  },
  v23c: {
    id:'v23c', type:'single', phase:'Huid & uiterlijk — verdieping',
    text:'Hoe oud voel je je huid ten opzichte van je leeftijd?',
    options:[
      {text:'Jonger — mijn huid ziet er goed uit',value:'jonger'},
      {text:'Op leeftijd',value:'normaal'},
      {text:'Ouder — ik zie het verouderen versnellen',value:'ouder',scores:{beauty:2}}
    ]
  },
  v24: {
    id:'v24', type:'single', phase:'Spijsvertering — verdieping',
    text:'Welke klachten herken jij het meest?',
    options:[
      {text:'Opgeblazen gevoel na het eten',value:'opgeblazen',scores:{spijsvertering:2}},
      {text:'Darmkrampen of buikpijn',value:'krampen',scores:{spijsvertering:2}},
      {text:'Onregelmatige stoelgang (diarree of constipatie)',value:'stoelgang',scores:{spijsvertering:2}},
      {text:'Brandend maagzuur of reflux',value:'reflux',scores:{spijsvertering:1}}
    ]
  },
  v24b: {
    id:'v24b', type:'single', phase:'Spijsvertering — verdieping',
    text:'Hoe vaak heb je darmklachten?',
    options:[
      {text:'Af en toe',value:'soms',scores:{spijsvertering:1}},
      {text:'Meerdere keren per week',value:'vaak',scores:{spijsvertering:2}},
      {text:'Dagelijks',value:'dagelijks',scores:{spijsvertering:3}}
    ]
  },
  v24c: {
    id:'v24c', type:'single', phase:'Spijsvertering — verdieping',
    text:'Heb je bepaalde voedselintoleranties of een diagnose?',
    options:[
      {text:'Nee, niets vastgesteld',value:'nee'},
      {text:'Lactose-intolerantie',value:'lactose'},
      {text:'Glutensensitiviteit of coeliakie',value:'gluten',scores:{spijsvertering:1}},
      {text:'PDS / IBS of andere diagnose',value:'pds',scores:{spijsvertering:2}}
    ]
  },
  v25: {
    id:'v25', type:'single', phase:'Immuunsysteem — verdieping',
    text:'Hoe vaak word je ziek (verkouden, griep etc.)?',
    options:[
      {text:'Zelden — minder dan 1 keer per jaar',value:'zelden'},
      {text:'Gemiddeld — 1 à 2 keer per jaar',value:'gemiddeld',scores:{immuunsysteem:1}},
      {text:'Regelmatig — 3 keer of meer per jaar',value:'regelmatig',scores:{immuunsysteem:2}},
      {text:'Vaak — ik ben bijna altijd ergens van aan het herstellen',value:'vaak',scores:{immuunsysteem:3}}
    ]
  },
  v25b: {
    id:'v25b', type:'single', phase:'Immuunsysteem — verdieping',
    text:'Hoe lang herstel je gemiddeld als je ziek bent?',
    options:[
      {text:'Snel — binnen 3 dagen',value:'snel'},
      {text:'Gemiddeld — 5 tot 7 dagen',value:'normaal',scores:{immuunsysteem:1}},
      {text:'Langzaam — meer dan een week',value:'langzaam',scores:{immuunsysteem:2}}
    ]
  },
  v26: {
    id:'v26', type:'single', phase:'Hormonen — verdieping',
    text:'Welke hormonale klachten herken je?',
    options:[
      {text:'Stemmingswisselingen rondom mijn cyclus',value:'cyclus',scores:{hormonen:2}},
      {text:'PMS — pijnlijk, vermoeid, prikkelbaar voor mijn periode',value:'pms',scores:{hormonen:2}},
      {text:'Overgangsklachten (opvliegers, slaap, stemming)',value:'overgang',scores:{hormonen:3}},
      {text:'Ik merk het niet zo specifiek',value:'geen',scores:{hormonen:1}},
      {text:'Nvt — dit is niet op mij van toepassing',value:'nvt',onlyFor:'man'}
    ]
  },
  vprev1: {
    id:'vprev1', type:'single', phase:'Preventief — verdieping',
    text:'Waar wil je preventief het meest op investeren?',
    options:[
      {text:'Huid & anti-aging',value:'huid_prev',scores:{beauty:2}},
      {text:'Immuunsysteem & weerstand',value:'immuun_prev',scores:{immuunsysteem:2}},
      {text:'Hart- en vaatstelsel',value:'hart'},
      {text:'Cognitie & hersenfunctie',value:'cognitief'},
      {text:'Gewrichten & mobiliteit',value:'gewrichten',scores:{pijn:1}},
      {text:'Alles — een brede aanpak',value:'alles'}
    ]
  },
  vprev2: {
    id:'vprev2', type:'single', phase:'Preventief — verdieping',
    text:'Hoe zou je je huidige leefstijl omschrijven?',
    options:[
      {text:'Gezond — ik slaap, beweeg en eet goed',value:'gezond'},
      {text:'Wisselend — sommige dingen goed, andere minder',value:'wisselend'},
      {text:'Druk — ik wil het beter doen maar heb weinig tijd',value:'druk'},
      {text:'Verbetering nodig — ik wil een reset',value:'reset'}
    ]
  },
  v27: {
    id:'v27', type:'single', phase:'Leefstijl',
    text:'Hoeveel alcohol drink je gemiddeld per week?',
    options:[
      {text:'Geen',value:'geen'},
      {text:'1–5 glazen',value:'weinig',scores:{lever:1}},
      {text:'6–14 glazen',value:'gemiddeld',scores:{lever:2}},
      {text:'Meer dan 14 glazen',value:'veel',scores:{lever:4}}
    ]
  },
  v28: {
    id:'v28', type:'single', phase:'Leefstijl',
    text:'Hoe zijn je maaltijden gemiddeld?',
    options:[
      {text:'Gevarieerd en vers bereid',value:'vers'},
      {text:'Mix van vers en kant-en-klaar',value:'mix',scores:{lever:1}},
      {text:'Veel bewerkt, snacks of fastfood',value:'bewerkt',scores:{lever:2}}
    ]
  },
  v29: {
    id:'v29', type:'single', phase:'Leefstijl',
    text:'Gebruik je medicijnen of heb je gezondheidsklachten waar je mee bij een arts bent?',
    options:[
      {text:'Nee',value:'nee'},
      {text:'Ja — bloeddruk, cholesterol of diabetes-gerelateerd',value:'cardiometabool',scores:{lever:1}},
      {text:'Ja — pijnstillers, antidepressiva of andere medicatie',value:'overig',scores:{lever:1}},
      {text:'Ja — meerdere medicijnen',value:'meerdere',scores:{lever:2}}
    ]
  },
  email: {
    id:'email', type:'email', phase:'Bijna klaar',
    text:'Jouw herstelplan staat klaar.',
    sub:'Vul je gegevens in om je persoonlijke analyse te ontvangen.'
  }
});